import { render } from "./zfmx.vue?vue&type=template&id=5505e1ac&scoped=true&ts=true"
import script from "./zfmx.vue?vue&type=script&lang=ts"
export * from "./zfmx.vue?vue&type=script&lang=ts"

import "./zfmx.vue?vue&type=style&index=0&id=5505e1ac&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5505e1ac"]])

export default __exports__